import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import CryptoJS from 'crypto-js';
import { Form, InputGroup, FormControl, Button } from 'react-bootstrap';
import ListPageLayout from './ui/ListPageLayout';
import DataTable from './ui/DataTable';
import ActionIcon from './ui/ActionIcon';
import { getClientsList, getClientById } from '../services/clientService';
import { api } from '../config/api';
import { useLayout } from '../layout/AppLayout';
import { showSuccess, showError, showInfo } from '../utils/toast';
import { getApiErrorMessage } from '../utils/apiError';
import { importClients as importClientsApi } from '../services/clientService';
import { buildClientImportPayloads } from '../utils/clientExport';

function Clients() {
  return (
    <ListPageLayout
      title="Client List"
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Clients', path: '/clients' },
        { label: 'Client List' },
      ]}
      backTo="/clients"
      actions={(
        <ClientListActions />
      )}
    >
      <ClientListSection />
    </ListPageLayout>
  );
}

function ClientListActions() {
  const { openFormModal } = useLayout();
  return (
    <Button variant="primary" className="hr-btn-primary" onClick={() => openFormModal('create-client')}>
      + Add Client
    </Button>
  );
}

export function ClientListSection() {

const [clientsList,setClientsList]= useState([]);
const { tableRefresh, openFormModal } = useLayout();
const [lgShow, setLgShow] = useState(false);
const [clientList,setClientList]= useState(null);
const [assignedUsers,setAssignedUsers]= useState([]);
const [selectedClientId, setSelectedClientId] = useState('');

const [show, setShow] = useState(false);
const [loading, setLoading] = useState(true);
const [loadError, setLoadError] = useState('');
const [filteredData, setFilteredData] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [filterUserType, setFilterUserType] = useState('');

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  let JWT_SECRET="ygsiahndCieqtkeresimsrcattoersmaigutiubliyellaueprtnernar"

  // Function to decrypt data
  const decryptData = (ciphertext, secret) => {
    const bytes = CryptoJS.AES.decrypt(ciphertext, secret);
    return bytes.toString(CryptoJS.enc.Utf8);
  };

  const getDecryptedData = (key) => {
    const encryptedValue = localStorage.getItem(key);
    if (encryptedValue) {
      return decryptData(encryptedValue, JWT_SECRET);
    }
    return null;
  };
const userType = getDecryptedData("User Type")

const readClientList = async (id) => {
  try {
    const JSOData = await getClientById(id);
    const client = Array.isArray(JSOData) ? JSOData[0] : JSOData;
    setClientList(client || null);
    handleShow();
  } catch (error) {
    console.error('Error fetching client details:', error);
    showError(getApiErrorMessage(error, 'Unable to load client details. Please try again.'));
  }
};

useEffect(() => {
    getClientList();
}, [tableRefresh.clients]);

const getClientList = async () => {
    setLoading(true);
    setLoadError('');
    try {
        const JSOData = await getClientsList();
        const list = JSOData?.clientUserCounts;
        setClientsList(Array.isArray(list) ? list : []);
    } catch (error) {
        console.error("Error fetching clients:", error);
        setClientsList([]);
        setLoadError(getApiErrorMessage(error, 'Failed to load clients.'));
    } finally {
        setLoading(false);
    }
}; 
      const deleteClientDetails = async (id) => {
        // Show a confirmation dialog to the user
        const isConfirmed = window.confirm("Are you sure you want to delete this client?");
    
        // If the user confirms, proceed with the deletion
        if (isConfirmed) {
            try {
                const { data: JSOData } = await api.delete(`/deleteClient/${id}`);
    
                if (JSOData.status === "success") {
                    showSuccess(JSOData.msg);
                    await getClientList();
                } else {
                    showError(JSOData.msg || 'Failed to delete client. Please try again.');
                }
            } catch (error) {
                console.error("Error deleting client:", error);
                showError(getApiErrorMessage(error, 'An error occurred while deleting the client. Please try again later.'));
            }
        } else {
            showInfo('Client deletion was canceled.');
        }
    };
    
    const userDetailsofAssignedClient = async (id) => {
      try {
        const { data } = await api.get(`/userDetailsofAssignedClient/${id}`);
        setAssignedUsers(Array.isArray(data.userDetails) ? data.userDetails : []);
      } catch (error) {
        console.error('Error fetching assigned users:', error);
        setAssignedUsers([]);
      }
  };
    
    const userDetailstoAssignClient = async (id) => {
      try {
        const { data } = await api.get(`/userDetailstoAssignClient/${id}`);
        const availableUsers = Array.isArray(data.userDetails) ? data.userDetails : [];
        setFilteredData(availableUsers);
        setSelectedClientId(id);
        await userDetailsofAssignedClient(id);
        setLgShow(true);
      } catch (error) {
        console.error('Error loading users to assign:', error);
        showError(getApiErrorMessage(error, 'Unable to load users for assignment. Please try again.'));
      }
  };

// //   useEffect(() => {
// //       filterUsers();
// //   }, [searchName, filterUserType]);

//   const filterUsers = () => {
//     // Ensure `usersData` is an array before filtering
//     let filtered = Array.isArray(usersData) ? usersData : [];
    
//     console.log("Initial data:", filtered);  // Debugging the original data

//     // Check if searchName is a valid string and filter by name
//     if (searchName?.trim()) {
//         filtered = filtered.filter(user => 
//             user.EmployeeName?.toLowerCase().includes(searchName.toLowerCase())
//         );
//         console.log("After filtering by name:", filtered);  // Debugging the result after filtering by name
//     }

//     // Check if filterUserType is provided and filter by user type
//     if (filterUserType?.trim()) {
//         filtered = filtered.filter(user => user.UserType === filterUserType);
//         console.log("After filtering by user type:", filtered);  // Debugging the result after filtering by user type
//     }

//     // Update the filtered data state
//     setFilteredData(filtered);
//     console.log("Final filtered data:", filtered);  // Debugging final result
// };

const filtereData = (Array.isArray(filteredData) ? filteredData : [])
    .filter((user) =>
        (user.EmployeeName || '').toLowerCase().includes(searchName.toLowerCase()) &&
        (filterUserType === '' || user.UserType === filterUserType)
    );


// Function to assign client to user
const assignClientToUser = async (userId) => {
    const clientId = selectedClientId; // Ensure you have a way to store the selected client ID

    // Show a confirmation dialog to the user
    const isConfirmed = window.confirm(`Are you sure you want to assign this client?`);

    // If the user confirms, proceed with the assignment
    if (isConfirmed) {
        try {
            const response = await api.post(`/assignClient/${userId}/${clientId}`);

            const result = response.data;

            if (result.status === 'success') {
                showSuccess('Client assigned successfully');
                await userDetailsofAssignedClient(clientId);
                await userDetailstoAssignClient(clientId);
                await getClientList();
            } else {
                showError(result.msg || 'Failed to assign client. Please try again.');
            }
        } catch (error) {
            console.error('Error assigning client:', error.response ? error.response.data : error.message);
            showError(getApiErrorMessage(error, 'An error occurred while assigning the client. Please try again later.'));
        }
    } else {
        showInfo('Client assignment was canceled.');
    }
};

// Function to unassign client from user
const unassignClientFromUser = async (userId) => {
    const clientId = selectedClientId; // Ensure you have a way to store the selected client ID

    // Show a confirmation dialog to the user
    const isConfirmed = window.confirm(`Are you sure you want to unassign this client?`);

    // If the user confirms, proceed with the unassignment
    if (isConfirmed) {
        try {
            const response = await api.post(`/unassignClient/${userId}/${clientId}`);

            const result = response.data;

            if (result.status === 'success') {
                showSuccess('Client unassigned successfully');
                await userDetailsofAssignedClient(clientId);
                await userDetailstoAssignClient(clientId);
                await getClientList();
            } else {
                showError(result.msg || 'Failed to unassign client. Please try again.');
            }
        } catch (error) {
            console.error('Error unassigning client:', error.response ? error.response.data : error.message);
            showError(getApiErrorMessage(error, 'An error occurred while unassigning the client. Please try again later.'));
        }
    } else {
        showInfo('Client unassignment was canceled.');
    }
};


  const clientColumns = [
    {
      key: 'clientCode',
      label: 'Client Code',
      sortable: true,
      render: (row) => (
        <button type="button" className="btn btn-link p-0" onClick={() => readClientList(row.clientId)}>
          <b>{row.clientCode}</b>
        </button>
      ),
    },
    {
      key: 'clientName',
      label: 'Client Name',
      sortable: true,
      render: (row) => (
        <Link
          to={`/Requirments?client=${encodeURIComponent(row.clientName || '')}`}
          className="hr-table-link-btn"
        >
          <b>{row.clientName}</b>
        </Link>
      ),
    },
    {
      key: 'typeOfService',
      label: 'Type Of Service',
      sortable: true,
      render: (row) => row.clientDetails?.typeOfService || 'N/A',
      exportValue: (row) => row.clientDetails?.typeOfService || 'N/A',
    },
    {
      key: 'location',
      label: 'Location',
      sortable: true,
      render: (row) => row.clientDetails?.location || 'N/A',
      exportValue: (row) => row.clientDetails?.location || 'N/A',
    },
    {
      key: 'assigns',
      label: 'Assigns',
      render: (row) => (
        <button
          type="button"
          className="hr-assign-badge"
          onClick={() => userDetailstoAssignClient(row.clientId)}
        >
          {row.userCount}/{row.userTypeCounts}
        </button>
      ),
    },
    {
      key: 'actions',
      label: 'Actions',
      render: (row) => (
        <div className="hr-table-actions">
          {userType === 'Admin' && (
            <>
              <ActionIcon variant="edit" src="/Images/edit.svg" alt="Edit client" onClick={() => openFormModal('edit-client', { id: row.clientId })} />
              <ActionIcon variant="delete" src="/Images/trash.svg" alt="Delete client" onClick={() => deleteClientDetails(row.clientId)} />
            </>
          )}
        </div>
      ),
    },
  ];

  const handleImportRows = async (rows) => {
    const payloads = buildClientImportPayloads(rows);
    if (!payloads.length) {
      showError('No valid rows found. Required columns: Client Code, Client Name.');
      return;
    }

    try {
      const result = await importClientsApi(payloads);
      if (result.created > 0) {
        showSuccess(result.msg || `Imported ${result.created} client(s).`);
        await getClientList();
      }
      if (result.failed?.length) {
        const codes = result.failed.map((item) => item.clientCode).join(', ');
        showError(`${result.failed.length} row(s) failed: ${codes}`);
      } else if (!result.created) {
        showError(result.msg || 'No clients were imported.');
      }
    } catch (error) {
      showError(getApiErrorMessage(error, 'Failed to import clients.'));
    }
  };

  return (
    <>
      {loadError && <div className="alert alert-danger">{loadError}</div>}

      {!loading && !loadError && (
        <p className="hr-list-summary">
          Showing <strong>{clientsList.length}</strong> clients
        </p>
      )}

      <DataTable
        columns={clientColumns}
        data={clientsList}
        rowKey="clientId"
        searchPlaceholder="Search by client name or code"
        searchKeys={['clientName', 'clientCode']}
        onRefresh={getClientList}
        onImportRows={handleImportRows}
        exportFileName="clients-export.csv"
        loading={loading}
        emptyMessage="No clients found."
      />

    <div className="hr-table-card">
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <strong className="me-auto">
            <b style={{ fontFamily: "monospace", margin: "5px" }}>Client Name:</b> {clientList?.ClientName}
          </strong>
          <small><b style={{ fontFamily: "monospace", margin: "5px" }}>Code:</b> {clientList?.ClientCode}</small>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "start" }}>
          {clientList ? (
            <>
              <p><b>Type Of Services:</b> {clientList.Services}</p>
              <p><b>Location:</b> {clientList.Location}</p>
              <p><b>1st Name:</b> {clientList.Name}</p>
              <p><b>1st Spoc:</b> {clientList.Spoc}</p>
              <p><b>1st Mobile Number:</b> {clientList.MobileNumber}</p>
              <p><b>1st Email:</b> {clientList.Email}</p>
              <p><b>2nd Name:</b> {clientList.Name1}</p>
              <p><b>2nd Spoc:</b> {clientList.Spoc1}</p>
              <p><b>2nd Mobile Number:</b> {clientList.MobileNumber1}</p>
              <p><b>2nd Email:</b> {clientList.Email1}</p>
              <p><b>3rd Name:</b> {clientList.Name2}</p>
              <p><b>3rd Spoc:</b> {clientList.Spoc2}</p>
              <p><b>3rd Mobile Number:</b> {clientList.MobileNumber2}</p>
              <p><b>3rd Email:</b> {clientList.Email2}</p>
            </>
          ) : (
            <p className="hr-empty-state">No client details available.</p>
          )}
        </Modal.Body>
      </Modal>
          <Modal size="lg" show={lgShow} onHide={() => setLgShow(false)} aria-labelledby="example-modal-sizes-title-lg">
    <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
            <h5>
                <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon" />
                <b style={{ fontFamily: "monospace" }}>Assign Client</b>
            </h5>
        </Modal.Title>
    </Modal.Header>
    <Modal.Body>
    {/* Search and Filter Controls */}
    <InputGroup className="mb-3">
        <FormControl
            placeholder="Search by Name"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)} // Update search input
        />
        <Form.Select
            aria-label="Filter by UserType"
            value={filterUserType}
            onChange={(e) => setFilterUserType(e.target.value)} // Update filter dropdown
        >
            <option value="">All</option>
            <option value="User">User</option>
            <option value="TeamLead">TeamLead</option>
            {/* Add more UserType options as needed */}
        </Form.Select>
    </InputGroup>

    {/* Table to Display Filtered Users */}
    <div className="table-responsive mb-3">
        <Table style={{ textAlign: "center" }}  responsive bordered hover className="table">
            <thead>
                <tr>
                    <th scope="col">Sno</th>
                    <th scope="col">Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">User Type</th>
                    <th scope="col">Action</th>
                </tr>
            </thead>
            <tbody>
                {filtereData.length > 0 ? (
                    filtereData.map((user, index) => (
                        <tr key={user._id}>
                            <th scope="row">{index + 1}</th>
                            <td>{user.EmployeeName || 'N/A'}</td>
                            <td>{user.Email || 'N/A'}</td>
                            <td>{user.UserType || 'N/A'}</td>
                            <td>
                                <button
                                    type="button"
                                    className="btn btn-link p-0"
                                    onClick={() => assignClientToUser(user._id)}
                                    style={{
                                        textDecoration: "none",
                                        fontWeight: "bold",
                                        backgroundColor: "lightsteelblue",
                                        padding: "5px",
                                        color: "black",
                                        borderRadius: "20px"
                                    }}
                                >
                                    Assign
                                </button>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                            No Users Found
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    </div>

    <hr />

    {/* Title for Assigned Users Table */}
    <center>
        <h5
            style={{
                backgroundColor: "lightgray",
                borderRadius: "30px",
                margin: "20px",
                padding: "2px"
            }}
        >
            <img
                style={{ width: "30px", margin: "10px" }}
                src='/Images/icon.png'
                alt="icon"
            />
            <b style={{ fontFamily: "monospace" }}>Assigned Users</b>
        </h5>
    </center>

    {/* Table to Display Assigned Users */}
    <div className="table-responsive">
        <Table  style={{ textAlign: "center" }}  responsive bordered hover className="table">
            <thead>
                <tr>
                    <th scope="col">Sno</th>
                    <th scope="col">Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">User Type</th>
                    <th colSpan={2} >Action</th>
                </tr>
            </thead>
            <tbody>
                {Array.isArray(assignedUsers) && assignedUsers.length > 0 ? (
                    assignedUsers.map((user, index) => (
                        <tr key={user._id}>
                            <th scope="row">{index + 1}</th>
                            <td>{user.EmployeeName || 'N/A'}</td>
                            <td>{user.Email || 'N/A'}</td>
                            <td>{user.UserType || 'N/A'}</td>
                            <td>
                                <span style={{
                                        textDecoration: "none",
                                        fontWeight: "bold",
                                        backgroundColor: "lightgreen",
                                        padding: "6px",
                                        color: "black",
                                        borderRadius: "20px"
                                    }}>
                                    Assigned
                                </span>
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-link p-0"
                                onClick={() => unassignClientFromUser(user._id)}
                                style={{
                                        textDecoration: "none",
                                        fontWeight: "bold",
                                        backgroundColor: "lightcoral",
                                        padding: "6px",
                                        color: "black",
                                        borderRadius: "20px"
                                    }}
                              >
                                Un Assign
                              </button>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                            No Assigned Users
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    </div>
</Modal.Body>

</Modal>

         
    </div>
    </>
  );
}

export default Clients;
